export enum Games {
  categories = "categories",
}
